import { createSelector } from 'reselect';

const selectOpportunities = (state: any) => state.opportunities;


export const selectOpportunitiesCurrentItem = createSelector([selectOpportunities], (opportunities) => opportunities.current);

export const selectOpportunitiesListItems = createSelector([selectOpportunities], (opportunities) => opportunities.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectOpportunitiesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectOpportunitiesQueryItems = createSelector([selectOpportunities], (customers) => customers.query);

export const selectOpportunitiesCreatedItem = createSelector([selectOpportunities], (opportunities) => opportunities.create);

export const selectOpportunitiesUpdatedItem = createSelector([selectOpportunities], (opportunities) => opportunities.update);

export const selectOpportunitiesReadItem = createSelector([selectOpportunities], (opportunities) => opportunities.read);

export const selectOpportunitiesDeletedItem = createSelector([selectOpportunities], (opportunities) => opportunities.delete);

export const selectOpportunitiesSearchedItems = createSelector([selectOpportunities], (opportunities) => opportunities.search);

export const selectOpportunitiesItemsCount = createSelector([selectOpportunities], (opportunities) => opportunities.count);

export const selectOpportunitiesItemsFilter = createSelector([selectOpportunities], (opportunities) => opportunities.filter);